(function() {
  const root = document.querySelector('.cl-cfg');
  if (!root) return;

  const animEls = root.querySelectorAll('.cl-cfg-anim');
  if (animEls.length > 0 && typeof IntersectionObserver !== 'undefined') {
    const animIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cl-cfg-visible');
          animIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    animEls.forEach(function(el) { animIo.observe(el); });

    setTimeout(function() {
      animEls.forEach(function(el) {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add('cl-cfg-visible');
        }
      });
    }, 800);
  } else {
    animEls.forEach(function(el) { el.classList.add('cl-cfg-visible'); });
  }

  const PRODUCTS = [
    { color: 'linear-gradient(135deg, #F5B0CB, #E88AAD)', title: 'Pink Daisy Playsuit' },
    { color: 'linear-gradient(135deg, #B5C9A6, #8FAA7B)', title: 'Sage Playsuit' },
    { color: 'linear-gradient(135deg, #F5E6A8, #E8D27A)', title: 'Butter Playsuit' },
    { color: 'linear-gradient(135deg, #2C3E50, #1A2536)', title: 'Midnight Playsuit' }
  ];

  const COLLECTIONS = ['All products', 'Playsuits', 'Summer Collection', 'New Arrivals'];

  const state = {
    display: 'slider',
    title: 'Playsuit Color',
    tag_prefix: 'related:',
    products_to_show: 20,
    source_collection_idx: 0,
    name_0: 'Pink Daisy',
    name_1: 'Sage',
    name_2: 'Butter',
    name_3: 'Midnight',
    badge_0: 'Best Seller',
    badge_1: 'New',
    badge_2: '',
    badge_3: 'Low Stock',
    badge_bg: '#F35D9C',
    badge_text_color: '#FFFFFF',
    selected: 0
  };

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return root.querySelectorAll(sel); }

  function render() {
    const titleEl = $('#clCfgBlockTitle');
    if (titleEl) titleEl.textContent = state.title;

    $$('.cl-cfg__rv-mode').forEach(function(m) {
      m.classList.toggle('is-on', m.dataset.clMode === state.display);
    });

    for (let i = 0; i < 4; i++) {
      const nameEls = $$('[data-cl-name="' + i + '"]');
      nameEls.forEach(function(el) { el.textContent = state['name_' + i]; });

      const badgeEls = $$('[data-cl-badge="' + i + '"]');
      badgeEls.forEach(function(el) {
        el.textContent = state['badge_' + i];
        el.style.background = state.badge_bg;
        el.style.color = state.badge_text_color;
      });

      const shapeEls = $$('[data-cl-shape="' + i + '"]');
      shapeEls.forEach(function(el) { el.style.background = PRODUCTS[i].color; });
    }

    $$('[data-cl-item]').forEach(function(el) {
      el.classList.toggle('is-on', parseInt(el.dataset.clItem) === state.selected);
    });
    $$('[data-cl-dd-item]').forEach(function(el) {
      el.classList.toggle('is-on', parseInt(el.dataset.clDdItem) === state.selected);
    });
    $$('[data-cl-sw]').forEach(function(el) {
      el.classList.toggle('is-on', parseInt(el.dataset.clSw) === state.selected);
    });

    const ddName = $('[data-cl-dd-name]');
    if (ddName) ddName.textContent = state['name_' + state.selected];
    const ddShape = $('[data-cl-dd-shape]');
    if (ddShape) ddShape.style.background = PRODUCTS[state.selected].color;

    const mockTitle = $('[data-cl-mock-title]');
    if (mockTitle) mockTitle.textContent = state['name_' + state.selected] + ' Playsuit';
    const mockImg = $('[data-cl-mock-img]');
    if (mockImg) mockImg.style.background = PRODUCTS[state.selected].color;

    $$('[data-cl-seg]').forEach(function(seg) {
      seg.querySelectorAll('[data-cl-seg-val]').forEach(function(btn) {
        btn.classList.toggle('is-on', btn.dataset.clSegVal === state.display);
      });
    });

    const pickLabel = $('[data-cl-pick-label]');
    if (pickLabel) pickLabel.textContent = COLLECTIONS[state.source_collection_idx];

    $$('[data-swatches]').forEach(function(group) {
      const key = group.dataset.swatches;
      const val = state[key];
      group.querySelectorAll('.cl-cfg__sw').forEach(function(sw) {
        sw.classList.toggle('is-on', sw.dataset.color && sw.dataset.color.toLowerCase() === (val || '').toLowerCase());
      });
    });

    $$('[data-color-pip]').forEach(function(pip) {
      const key = pip.dataset.colorPip;
      pip.style.background = state[key];
    });

    $$('[data-color-input]').forEach(function(input) {
      const key = input.dataset.colorInput;
      if (document.activeElement !== input) input.value = (state[key] || '').toUpperCase();
    });
  }

  $$('[data-cl-tab]').forEach(function(tab) {
    tab.addEventListener('click', function() {
      const key = tab.getAttribute('data-cl-tab');
      $$('[data-cl-tab]').forEach(function(t) {
        t.classList.toggle('is-on', t === tab);
      });
      $$('[data-cl-pane]').forEach(function(p) {
        p.classList.toggle('is-on', p.getAttribute('data-cl-pane') === key);
      });
    });
  });

  $$('[data-cl-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      const key = input.dataset.clInput;
      state[key] = input.value;
      render();
    });
  });

  $$('[data-cl-seg-val]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.display = btn.dataset.clSegVal;
      render();
    });
  });

  const pickBtn = $('[data-cl-pick-cycle]');
  if (pickBtn) {
    pickBtn.addEventListener('click', function() {
      state.source_collection_idx = (state.source_collection_idx + 1) % COLLECTIONS.length;
      render();
    });
  }

  $$('.cl-cfg__sw[data-color]').forEach(function(sw) {
    sw.addEventListener('click', function() {
      const group = sw.closest('[data-swatches]');
      const key = group.dataset.swatches;
      state[key] = sw.dataset.color;
      render();
    });
  });

  $$('[data-color-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      const key = input.dataset.colorInput;
      let val = input.value.trim();
      if (!val.startsWith('#')) val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val) || /^#[0-9A-Fa-f]{3}$/.test(val)) {
        state[key] = val;
        render();
      }
    });
  });

  $$('[data-slider]').forEach(function(slider) {
    const key = slider.dataset.slider;
    const min = parseInt(slider.dataset.min);
    const max = parseInt(slider.dataset.max);
    const fill = slider.querySelector('.cl-cfg__slider-fill');
    const knob = slider.querySelector('.cl-cfg__slider-knob');
    const valEl = root.querySelector('[data-slider-val="' + key + '"]');

    function setFromValue(val) {
      val = Math.max(min, Math.min(max, val));
      val = Math.round(val);
      state[key] = val;
      const pct = ((val - min) / (max - min)) * 100;
      fill.style.width = pct + '%';
      knob.style.left = pct + '%';
      if (valEl) valEl.value = val;
      render();
    }

    function setFromX(clientX) {
      const rect = slider.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      const raw = min + pct * (max - min);
      setFromValue(raw);
    }

    let dragging = false;
    slider.addEventListener('mousedown', function(e) {
      dragging = true;
      setFromX(e.clientX);
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) { if (dragging) setFromX(e.clientX); });
    document.addEventListener('mouseup', function() { dragging = false; });
    slider.addEventListener('touchstart', function(e) {
      dragging = true;
      setFromX(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchmove', function(e) {
      if (dragging) setFromX(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchend', function() { dragging = false; });
  });

  const HANDLES = ['pink-daisy', 'sage', 'butter', 'midnight'];
  const redirectEl = $('#clCfgRedirect');
  const redirectHandleEl = $('[data-cl-redirect-handle]');
  let redirectTimer = null;

  function triggerRedirect(idx) {
    if (idx === state.selected) return;
    if (redirectTimer) clearTimeout(redirectTimer);
    if (redirectHandleEl) redirectHandleEl.textContent = HANDLES[idx];
    if (redirectEl) redirectEl.classList.add('is-on');
    redirectTimer = setTimeout(function() {
      state.selected = idx;
      render();
      if (redirectEl) redirectEl.classList.remove('is-on');
      redirectTimer = null;
    }, 1400);
  }

  $$('[data-cl-item]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      triggerRedirect(parseInt(el.dataset.clItem));
    });
  });

  $$('[data-cl-dd-item]').forEach(function(el) {
    el.addEventListener('click', function() {
      const dd = root.querySelector('.cl-cfg__rv-mode--dropdown');
      if (dd) dd.classList.remove('is-open');
      triggerRedirect(parseInt(el.dataset.clDdItem));
    });
  });

  $$('[data-cl-sw]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      triggerRedirect(parseInt(el.dataset.clSw));
    });
  });

  const ddToggle = root.querySelector('.cl-cfg__rv-dd-toggle');
  if (ddToggle) {
    ddToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const dd = root.querySelector('.cl-cfg__rv-mode--dropdown');
      if (dd) dd.classList.toggle('is-open');
    });
    document.addEventListener('click', function(e) {
      const dd = root.querySelector('.cl-cfg__rv-mode--dropdown');
      if (dd && !dd.contains(e.target)) dd.classList.remove('is-open');
    });
  }

  const track = root.querySelector('.cl-cfg__rv-track');
  if (track) {
    let isDown = false;
    let hasMoved = false;
    let startX = 0;
    let scrollStart = 0;

    track.addEventListener('mousedown', function(e) {
      isDown = true;
      hasMoved = false;
      startX = e.pageX;
      scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      const walk = startX - e.pageX;
      if (Math.abs(walk) > 5) hasMoved = true;
      track.scrollLeft = scrollStart + walk;
    });

    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('touchstart', function(e) {
      isDown = true;
      hasMoved = false;
      startX = e.touches[0].pageX;
      scrollStart = track.scrollLeft;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      if (!isDown) return;
      const walk = startX - e.touches[0].pageX;
      if (Math.abs(walk) > 5) hasMoved = true;
      track.scrollLeft = scrollStart + walk;
    }, { passive: true });

    track.addEventListener('touchend', function() {
      isDown = false;
    });

    track.addEventListener('click', function(e) {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  const arrow = root.querySelector('.cl-cfg__rv-arrow');
  if (arrow && track) {
    arrow.addEventListener('click', function() {
      const max = track.scrollWidth - track.clientWidth;
      const next = track.scrollLeft + 180;
      track.scrollTo({ left: next > max ? 0 : next, behavior: 'smooth' });
    });
  }

  const grid = $('#clCfgGrid');
  const seeLiveBtn = $('#clCfgSeeLive');
  if (seeLiveBtn && grid) {
    seeLiveBtn.addEventListener('click', function() {
      const isPreview = grid.classList.toggle('is-preview');
      seeLiveBtn.classList.toggle('is-back', isPreview);
      if (isPreview) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  render();
})();

(function() {
  var sections = document.querySelectorAll('.cl-cfg');
  if (!sections.length) return;

  var headerHideObserver = new IntersectionObserver(function(entries) {
    var anyVisible = entries.some(function(e) { return e.isIntersecting; });
    if (anyVisible) {
      document.body.classList.add('cl-cfg-section-active');
    } else {
      var stillVisible = false;
      sections.forEach(function(el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.5 && r.bottom > 80) {
          stillVisible = true;
        }
      });
      if (!stillVisible) {
        document.body.classList.remove('cl-cfg-section-active');
      }
    }
  }, { threshold: 0, rootMargin: '-80px 0px -50% 0px' });

  sections.forEach(function(sec) { headerHideObserver.observe(sec); });
})();